var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cozeMain",staticClass:"cozeMain"},[_c('CozeChat',{attrs:{"agentId":"7555045828235542554","cozeWidth":_vm.cozeWidth,"title":"智能考试评价助手"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }